<template>
  <div>
    <div class="relative flex flex-col mb-6 mt-12 z-10">
      <h1 class="ang-heading mb-8">KALKULATOR WAKACJI KREDYTOWYCH</h1>
      <div class="ang-card">
        <div class="ang-card-body p-10 cursor-default">
          <div class="row">
            <div class="col-12 mb-4">
              <div class="row mb-4">
                <div class="col-12">
                  <h6 class="text-base font-medium mb-4">
                    Policz, ile zyskasz na wakacjach kredytowych
                  </h6>
                  <p class="text-sm mb-4">
                    Sprawdź w
                    <span class="font-semibold"
                      >Kalkulatorze Wakacji Kredytowych ANG</span
                    >, na ile opłaca Ci się skorzystać z wakacji kredytowych.
                    Dzięki temu dowiesz się, jaką kwotę możesz
                    <span class="font-semibold">zaoszczędzić</span> w zależności
                    od decyzji, jaką podejmiesz. W naszym kalkulatorze masz
                    <span class="font-semibold">trzy możliwości</span>:
                  </p>
                  <ul>
                    <li>
                      - nadpłacasz kredyt hipoteczny i skracasz okres spłaty
                      kredytu;
                    </li>
                    <li>
                      - nadpłacasz kredyt hipoteczny i zmniejszasz ratę kredytu;
                    </li>
                    <li>- nie korzystasz z możliwości nadpłaty</li>
                  </ul>
                  <p class="text-red-700">
                    <span class="font-semibold">PAMIĘTAJ!</span> Poniższe
                    wyliczenia mają
                    <span class="font-semibold">charakter orientacyjny</span> i
                    mają zastosowanie dla
                    <span class="font-semibold">rat równych</span>. Nie
                    uwzględniają one kosztów ubezpieczenia, ewentualnych opłat
                    związanych z zawieraniem aneksów do umowy kredytowej w
                    związku ze skróceniem okresu kredytowania.
                    <span class="font-semibold"
                      >Koszty te są odmienne w każdym banku.</span
                    >
                    Dodatkowo kalkulator bazuje na podanej przez Ciebie
                    wysokości oprocentowania (rzeczywiste oprocentowanie w
                    <span class="font-semibold"
                      >przyszłości może ulegać zmianie</span
                    >
                    zgodnie z postanowieniami Twojej umowy kredytowej).
                  </p>
                  <!-- <a
                    href="#"
                   class="btn ang-button _bg_color2 py-1.5 px-4"
                  >
                    Sprawdź
                  </a> -->
                </div>
              </div>
              <form
                role="form"
                id="credit-holidays-form"
                class="mb-6 p-5 border border-gray-200 rounded-lg"
                method="POST"
                novalidate="novalidate"
              >
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label
                        class="ang-form-label sm:min-h-full"
                        for="current_balance"
                      >
                        Kwota kredytu pozostała do spłaty
                      </label>
                      <div class="relative">
                        <input
                          type="text"
                          class="ang-form-control !pr-10 num"
                          id="current_balance"
                          name="current_balance"
                          required
                          v-model="current_balance"
                        />
                        <span
                          class="absolute top-1/2 translate-y-[-50%] right-[12px] text-[#d1d1d1]"
                          >PLN</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label
                        class="ang-form-label sm:min-h-full"
                        for="current_interest"
                      >
                        Oprocentowanie
                      </label>
                      <div class="relative">
                        <input
                          type="text"
                          class="ang-form-control !pr-10 num"
                          id="current_interest"
                          name="current_interest"
                          required
                          v-model="current_interest"
                        />
                        <span
                          class="absolute top-1/2 translate-y-[-50%] right-[12px] text-[#d1d1d1]"
                          >%</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label class="ang-form-label" for="current_interest">
                        Pozostały okres kredytowania
                      </label>
                      <div class="relative">
                        <input
                          type="text"
                          class="ang-form-control !pr-10 digits"
                          id="rest_period"
                          name="rest_period"
                          :min="min_period"
                          :max="420"
                          required
                          v-model="rest_period"
                        />
                        <span
                          class="absolute top-1/2 translate-y-[-50%] right-[12px] text-[#d1d1d1]"
                          >msc</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label class="ang-form-label" for="current_interest">
                        Data najbliższej raty
                      </label>
                      <div class="relative">
                        <input
                          type="text"
                          class="ang-form-control !pr-10 datepicker dateAfterYesterday"
                          id="next_installment_date"
                          name="next_installment_date"
                          required
                          v-model="next_installment_date"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="form-group flex justify-end mb-0 mt-1 md:justify-end"
                    >
                      <button
                        :disabled="loading || counter > 0"
                        type="submit"
                        class="btn ang-button py-1.5 px-4 _bg_color1"
                      >
                        Oblicz
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="rest_period < min_period">
                  <div class="col-12 text-red-700 mt-3">
                    Jeżeli chcesz skorzystać z wakacji kredytowych ostatnia rata
                    Twojego kredytu musi być wyznaczona na nie wcześniej niż
                    styczeń 2023. W efekcie minimalna liczba miesięcy
                    pozostałych do spłaty to {{ min_period }}.
                  </div>
                </div>
              </form>

              <div
                v-if="loading || counter > 0"
                class="flex justify-center my-4"
              >
                <spinner />
              </div>
              <div v-show="!loading && counter === 0 && sent" class="row mb-4">
                <div class="col-12">
                  <div class="alert alert-success ang-alert-success mt-3">
                    <h6 class="text-base font-medium mb-4">
                      Dziękujemy za wysłanie formularza
                    </h6>
                    <p class="text-sm">
                      Dzięki wakacjom kredytowym możesz zaoszczędzić 100.000 zł,
                      a na koniec wakacji rata Twojego kredytu będzie wynosiła
                      2000 zł.
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mb-8" v-if="result && !loading && counter === 0">
                <div class="col-12">
                  <h6 class="text-base font-medium mb-3">
                    Efekt skorzystania z wakacji kredytowych
                    <small
                      >(zawieszenia spłaty
                      {{ result.holidays.length }} rat)</small
                    >
                  </h6>
                  <div class="p-5 border border-gray-200 rounded-lg mb-6">
                    <p>
                      W poniższej symulacji uwzględniono wakacje kredytowe w
                      następujących miesiącach:
                    </p>
                    <span
                      class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded text-green-600 bg-green-200 uppercase last:mr-0 mr-1 mt-2"
                      v-for="(e, i) in result.holidays"
                      :key="'info_holidays_' + i"
                    >
                      {{ moment(e) }}
                    </span>

                    <p
                      v-if="next_installment_date === current_date"
                      class="text-red-700 mt-3"
                    >
                      <strong
                        >UWAGA: Wybrałeś płatność raty w dniu dzisiejszym.
                        Pamiętaj, że banki wymagają co do zasady złożenia
                        wniosku o zawieszenie spłaty raty kredytu na co najmniej
                        dzień przed datą płatności raty. Twój bank może nie
                        uwzględnić wniosku złożonego w dniu płatności raty –
                        zweryfikuj to w swoim banku.</strong
                      >
                    </p>
                  </div>
                  <div class="flex justify-center mb-3 block md:hidden">
                    <img src="assets/img/arrow.png" style="height: 30px" />
                  </div>
                  <div class="overflow-x-auto">
                    <table class="min-w-full leading-normal">
                      <thead>
                        <tr>
                          <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 tracking-wider"
                          >
                            Sposób wykorzystania środków
                          </th>
                          <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 tracking-wider"
                          >
                            Nadpłata i skrócenie okresu
                          </th>
                          <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 tracking-wider"
                          >
                            Nadpłata i zmniejszenie raty
                          </th>
                          <th
                            class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 tracking-wider"
                          >
                            Bez nadpłaty
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="result.profits">
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm font-bold"
                          >
                            Koszt kredytu
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.profits[2]"></span>
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.profits[1]"></span>
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.profits[3]"></span>
                          </td>
                        </tr>
                        <tr v-if="result.periods">
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm font-bold"
                          >
                            Okres kredytowania
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.periods[2]"></span>
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.periods[1]"></span>
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.periods[3]"></span>
                          </td>
                        </tr>
                        <tr v-if="result.installments">
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm font-bold"
                          >
                            Wysokość raty
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.installments[2]"></span>
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span
                              v-html="result.installments[1]"
                              class="block"
                            ></span>
                            <div class="flex justify-start mt-2">
                              <button
                                type="button"
                                class="btn ang-button py-1 px-2 _bg_color2 text-[11px]"
                                @click.stop.prevent="showScheduleModal = true"
                              >
                                Zobacz harmonogram
                              </button>
                            </div>
                          </td>
                          <td
                            class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
                          >
                            <span v-html="result.installments[3]"></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mb-8">
              <div
                class="bg-[#fff7e1] border-2 border-solid border-[#FFE6A4] rounded-xl px-5 py-5"
              >
                <div class="row">
                  <div class="col-12 col-lg-12 mt-2">
                    <div class="">
                      <p class="text-lg font-medium mb-5">
                        Umów bezpłatną konsultację
                      </p>
                      <p class="">
                        Jeżeli planujesz skorzystać z Wakacji kredytowych 2024,
                        koniecznie sprawdź nasz kalkulator i dowiedz się ile
                        możesz zaoszczędzić. Pamietaj jednak, że nić nie zastąpi
                        rozmowy z ekspertem ANG Odpowiedzialne Finanse! Umów się
                        na bezpłatna konsultację kredytową!
                        <!-- W dobie <span class="font-medium">rosnących stóp procentowych</span> i wysokich kosztów kredytów hipotecznych, <span class="font-medium">wakacje kredytowe</span> stały się jednym z rozwiązań, które mają pomóc wielu osobom w tej trudnej sytuacji. Dlatego <span class="font-medium">stworzyliśmy kalkulator</span>, dzięki któremu sprawdzisz, ile możesz oszczędzić na wakacjach kredytowych. Pamiętaj jednak, że nic nie zastąpi <span class="font-medium">indywidualnej rozmowy z ekspertem Grupy ANG!</span> Umów się na bezpłatną konsultację kredytową! -->
                      </p>
                    </div>
                    <div class="flex justify-end">
                      <a
                        href="#"
                        class="flex justify-center bg-[#0F92AA] text-white px-4 py-2 rounded-xl mt-3 hover:cursor-pointer hover:no-underline"
                        @click.stop.prevent="showContactModal = true"
                        >Bezpłatna konsultacja</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-8">
              <h6 class="text-base font-medium mb-4">
                Najpopularniejsze pytania dotyczące wakacji kredytowych
              </h6>
              <div class="accordion" id="accordionQA">
                <div class="accordion-item bg-white border border-gray-200">
                  <h2 class="mb-0 px-1">
                    <button
                      @click.stop.prevent="section = 1"
                      class="accordion-button relative flex items-center w-full py-4 px-5 text-base shadow-none text-left bg-white rounded-none transition focus:outline-none font-medium text-gray-500 hover:text-gray-500"
                      type="button"
                      :aria-expanded="section === 1"
                    >
                      <span class="pr-3">
                        Wakacje kredytowe – co trzeba zrobić, aby z nich
                        skorzystać?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="firstQuestion"
                    class="accordion-collapse px-1 collapse"
                    :class="{ show: section === 1 }"
                  >
                    <div class="accordion-body pb-4 px-5">
                      <p>
                        Ustawa, która umożliwia skorzystanie z tzw. wakacji
                        kredytowych skierowana jest do osób, które:
                      </p>
                      <ul class="py-2">
                        <li>
                          – posiadają kredyt hipoteczny udzielony w walucie
                          polskiej (można posiadać kilka kredytów, ale z wakacji
                          kredytowych można skorzystać wyłącznie co do jednego z
                          nich);
                        </li>
                        <li>
                          – kredyt został zaciągnięty, aby zaspokoić własne
                          potrzeby mieszkaniowe;
                        </li>
                        <li>
                          – umowa kredytowa została zawarta przed 1 lipca 2022
                          r.,
                        </li>
                        <li>– wartość kredytu jest niższa niż 1,2 mln zł;</li>
                        <li>
                          – średnia arytmetyczna wartości wskaźnika RdD (Rata do
                          Dochodu) gospodarstwa domowego za okres ostatnich
                          trzech miesięcy poprzedzających miesiąc złożenia
                          wniosku o skorzystanie z wakacji kredytowych nie
                          przekracza 30% lub
                        </li>
                        <li>– wychowują co najmniej troje dzieci.</li>
                      </ul>
                      <p>
                        Oznacza to, że z wakacji kredytowych nie będą mogły
                        skorzystać osoby mające kredyty hipoteczne np. we franku
                        szwajcarskim czy w euro. Po drugie nie będzie można
                        zawiesić rat kredytu, który był przeznaczony na własne
                        potrzeby mieszkaniowe .
                      </p>
                      <!-- <p class="py-4">
                        Z kolei poniższy przykład pokazuje o co dokładnie chodzi
                        jeśli chodzi o warunek dotyczący daty zawarcia umowy i
                        daty zakończenia spłaty kredytu hipotecznego:
                      </p>
                      <p>
                        Mamy umowę kredytu hipotecznego zawartą w dniu
                        12.05.2016 r.. Termin jej zakończenia spłaty całego
                        kredytu przypada na 25.10.2022 r. W takiej sytuacji nie
                        będzie możliwe wzięcie wakacji kredytowych. Byłoby to
                        możliwe gdyby termin zakończenia okresu kredytowania
                        przypadał po 1 stycznia 2023 r. Oczywiście w każdym
                        przypadku muszą być spełnione warunki takie jak waluta i
                        cel kredytu.
                      </p> -->
                    </div>
                  </div>
                </div>
                <div
                  class="accordion-item border-b-0 border-t-0 bg-white border border-gray-200"
                >
                  <h2 class="mb-0 px-1">
                    <button
                      @click.stop.prevent="section = 2"
                      class="accordion-button relative flex items-center w-full py-4 px-5 text-base shadow-none text-left bg-white rounded-none transition focus:outline-none font-medium text-gray-500 hover:text-gray-500"
                      type="button"
                      :aria-expanded="section === 2"
                    >
                      <span class="pr-3">
                        Co oznacza zapis „zaspokojenia własnych potrzeb
                        mieszkaniowych” będący warunkiem wzięcia wakacji
                        kredytowych?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="secondQuestion"
                    class="accordion-collapse px-1 collapse"
                    :class="{ show: section === 2 }"
                  >
                    <div class="accordion-body pb-4 px-5">
                      <p>
                        Trudno jednoznacznie odpowiedzieć na to pytanie, bo w
                        ustawie nie ma definicji „własnych potrzeb
                        mieszkaniowych”. Można założyć, że liczy się zamiar z
                        chwili zaciągania kredytu hipotecznego. Co to znaczy?
                        Należy to rozumieć w ten sposób, że w chwili zawierania
                        umowy o kredyt hipoteczny nabywana nieruchomość miała
                        zaspokoić własne potrzeby mieszkaniowe kredytobiorcy.
                        Później sytuacja mogła ulec zmianie, tzn. kredytobiorca
                        np. przeprowadził się do innej nieruchomości i np.
                        zakupioną na kredyt nieruchomość aktualnie wynajmuje.
                        Nie miał jednak tego zamiaru w chwili zawierania umowy
                        kredytu hipotecznego.
                      </p>
                      <p class="py-2">
                        Inaczej ma się sprawa, gdy kredytobiorca od razu zakupił
                        nieruchomość na kredyt i jego ówczesnym celem miała być
                        ona wynajmowana, a nie przeznaczona na zamieszkanie w
                        niej przez kredytobiorcę.
                      </p>
                      <!-- <p>
                        Możliwe, że będzie liczył się sam zamiar z chwili
                        zaciągania kredytu hipotecznego. Tzn. w momencie
                        zawierania umowy o kredyt hipoteczny nabywana
                        nieruchomość miała zaspokoić własne potrzeby
                        mieszkaniowe kredytobiorcy. Z czasem sytuacja mogła się
                        zmienić np. kredytobiorca przeprowadził się do innej
                        nieruchomości a zakupioną na kredyt nieruchomość
                        aktualnie wynajmuje. Nie miał jednak tego zamiaru w
                        chwili zawierania umowy kredytu hipotecznego.
                      </p>
                      <p class="py-2">
                        Zupełnie innym przypadkiem jest gdy kredytobiorca od
                        razu zakupił nieruchomość na kredyt i jego celem od
                        początku miał być wynajem, a nie cele mieszkaniowe.
                      </p> -->
                    </div>
                  </div>
                </div>
                <div
                  class="accordion-item bg-white border-b-0 border border-gray-200"
                >
                  <h2 class="mb-0 px-1" id="headingThree">
                    <button
                      @click.stop.prevent="section = 3"
                      class="accordion-button relative flex items-center w-full py-4 px-5 text-base shadow-none text-left bg-white rounded-none transition focus:outline-none font-medium text-gray-500 hover:text-gray-500"
                      type="button"
                      :aria-expanded="section === 3"
                    >
                      <span class="pr-3">
                        Czy aby skorzystać z wakacji kredytowych trzeba spełniać
                        określone kryteria dochodowe?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="thirdQuestion"
                    class="accordion-collapse px-1 collapse"
                    :class="{ show: section === 3 }"
                  >
                    <div class="accordion-body pb-4 px-5">
                      <p>
                        Nowelizacja ustawy o finansowaniu społecznościowym dla
                        przedsięwzięć gospodarczych i pomocy kredytobiorcom,
                        która przedłuża funkcjonowanie wakacji kredytowych na
                        rok 2024 uzależnia możliwość skorzystania z nich od
                        wysokości raty kredytu w stosunku do dochodów
                        gospodarstwa domowego kredytobiorcy (wskaźnik RdD). Aby
                        kredytobiorca mógł wystąpić o zawieszenie płatności
                        średnia arytmetyczna wartości wskaźnika RdD za okres
                        ostatnich trzech miesięcy poprzedzających miesiąc
                        złożenia wniosku nie może przekroczyć 30%.
                      </p>
                      <p class="py-2">
                        Trzeba jednak zaznaczyć, że warunek ten nie dotyczy
                        osób, które mają na utrzymaniu co najmniej troje dzieci.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="accordion-item bg-white border-b-0 border border-gray-200"
                >
                  <h2 class="mb-0 px-1" id="headingFourth">
                    <button
                      @click.stop.prevent="section = 4"
                      class="accordion-button relative flex items-center w-full py-4 px-5 text-base shadow-none text-left bg-white rounded-none transition focus:outline-none font-medium text-gray-500 hover:text-gray-500"
                      type="button"
                      :aria-expanded="section === 4"
                    >
                      <span class="pr-3">
                        Gdzie należy złożyć wniosek o wakacje kredytowe?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="fourthQuestion"
                    class="accordion-collapse px-1 collapse"
                    :class="{ show: section === 4 }"
                  >
                    <div class="accordion-body pb-4 px-5">
                      <p>
                        Wniosek będzie można złożyć w banku, w którym
                        zaciągnięty został kredyt. Poszczególne banki deklarują,
                        że będzie można to zrobić zarówno pisemnie jak również
                        elektronicznie (np. w systemie bankowości internetowej).
                        Razem z wnioskiem o skorzystanie z wakacji kredytowych
                        trzeba będzie złożyć również oświadczenie o spełnieniu
                        warunku dotyczącego stosunku raty do średniego dochodu
                        lub posiadania min trojga dzieci.. Warto pamiętać, że
                        wspomniane oświadczenie musi także zawierać następującą
                        klauzulę: "Jestem świadomy odpowiedzialności karnej za
                        złożenie fałszywego oświadczenia.”
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item bg-white border border-gray-200">
                  <h2 class="mb-0 px-1" id="headingFifth">
                    <button
                      @click.stop.prevent="section = 5"
                      class="accordion-button relative flex items-center w-full py-4 px-5 text-base shadow-none text-left bg-white rounded-none transition focus:outline-none font-medium text-gray-500 hover:text-gray-500"
                      type="button"
                      :aria-expanded="section === 5"
                    >
                      <span class="pr-3">
                        Czy podczas wakacji kredytowych istnieje możliwość
                        nadpłacenia kredytu hipotecznego?</span
                      >
                    </button>
                  </h2>
                  <div
                    id="fifthQuestion"
                    class="accordion-collapse px-1 collapse"
                    :class="{ show: section === 5 }"
                  >
                    <div class="accordion-body pb-4 px-5">
                      <p>
                        Ustawa wprowadzająca wakacje kredytowe nie zakłada
                        ograniczeń dotyczących nadpłacania kredytu w okresie
                        korzystania z wakacji kredytowych. Chcąc w tym czasie
                        nadpłacić kredyt hipoteczny objęty wakacjami należy
                        zapoznać się z warunkami nadpłaty określonymi w
                        konkretnej umowie kredytowej.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="bg-[#fff7e1] border-2 border-solid border-[#FFE6A4] rounded-xl px-5 py-5 mt-6"
              >
                <p class="text-base">
                  Sprawdź inne najczęściej zadawane pytania na temat wakacji
                  kredytowych w "Przewodniku po wakacjach kredytowych ANG"
                </p>
                <div class="">
                  <p class="mt-6">
                    Wakacje kredytowe wzbudzają wiele emocji, pytań i
                    wątpliwości. Dlatego oprócz kalkulatora stworzyliśmy
                    "Przewodnik po wakacjach kredytowych", w którym znajdziesz
                    najczęstsze pytania i odpowiedzi klientów.
                  </p>
                  <p class="py-2">
                    Pytania opracował Tomasz Bujański z zespołu Wsparcia
                    kredytów hipotecznych ANG Odpowiedzialne Finanse.
                  </p>
                </div>
                <div class="flex justify-end">
                  <a
                    target="_blank"
                    href="https://angfinanse.pl/wakacje-kredytowe-przewodnik-ang/ "
                    class="flex justify-center bg-[#e94153] text-white px-4 py-2 rounded-xl mr-3 mt-3 hover:cursor-pointer hover:no-underline"
                  >
                    Przewodnik ANG</a
                  >
                </div>
              </div>

              <div class="row mt-4 text-center">
                <div class="col-12 col-lg-12 mt-4">
                  <div class="">
                    <p class="">
                      <span class="text-base"
                        >A może potrzebujesz indywidualnej konsultacji
                        kredytowej?
                      </span>
                      <br />
                      <span class="mt-4 font-semibold"
                        >Umów się na spotkanie z naszym ekspertem!</span
                      >
                    </p>
                  </div>
                  <div class="flex justify-center">
                    <a
                      href="#"
                      class="flex justify-center bg-[#0F92AA] text-white px-4 py-2 rounded-xl mt-3 hover:cursor-pointer hover:no-underline"
                      @click.stop.prevent="showContactModal = true"
                      >Bezpłatna konsultacja</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="deco-4">
      <div class="parallax-scene">
        <svg
          class="parallax-move"
          data-depth="0.4"
          height="226.12"
          viewBox="0 0 222.922 226.12"
          width="222.922"
        >
          <path
            d="M152.318 155.231c-8.283 6.18-21.242 2.146-37.635-3.187-25.472-8.286-23.941-14.048-35.653-14.508-20.199-.793-26.436 16.274-46.978 13.665-2.8-.356-15.594-1.979-20.159-10.578-7.85-14.792 11.33-45.223 36.242-55.391 12.282-5.014 23.97-4.294 44.123-3.05 27.015 1.667 35.371 7.761 46.188 1.495 13.407-7.766 9.779-22.462 20.207-26.726 19.37-7.923 60.748 30.97 54.278 48.263-5.292 14.117-39.544 5.884-51.77 28.451-5.162 9.53-2.022 16.48-8.843 21.566z"
            fill="#11A68A"
          ></path>
        </svg>
      </div>
    </div>
    <div class="deco-2">
      <div class="parallax-scene">
        <svg
          width="291"
          height="301"
          class="parallax-move"
          data-depth="0.4"
          viewBox="0 0 290.8 301.08"
        >
          <path
            d="M181.24 268.83c-31.74-6.2-50.08 15.86-62.26 7.02-11.8-8.57 3.2-30.91-9.95-48.42-12.47-16.6-33.28-6.33-53.6-20.08-27.6-18.68-39.29-71.48-20.51-94.07 24.06-28.93 89.26 2.43 106.9-26.45 9.81-16.07-6.37-32.26 3.89-45.48 17.77-22.9 93.16-8.8 102.43 21.79 7.87 26-38.3 43.14-34.86 82.29 3.09 35.18 42.11 41.11 41.82 75.45-.23 27.1-24.82 55.31-46.76 56.6-10.66.64-11.66-5.63-27.1-8.65z"
            fill="#FFD433"
          ></path>
        </svg>
      </div>
    </div>
    <div class="deco-3 absolute right-0 bottom-[-40px]">
      <div class="parallax-scene">
        <svg viewBox="0 0 510.24 283.46">
          <path
            class="parallax-move"
            data-depth="0.4"
            d="M432.42 93.64c-19.89-25-83.49 14-122.88-23.45-16.63-15.81-14.86-31.86-31.92-37.65-20.72-7-44.18 9.58-73.71 31-45.88 33.35-39 44-62.32 52.54-40.16 14.81-63.88-15.49-103.54 3.2-5.41 2.54-30.12 14.19-33.68 34.49-6.14 34.93 52.39 83.67 109.22 87.86 28 2.07 51.08-7 90.86-22.72 53.32-21 66.16-38.76 92-33.22 32.09 6.87 34.39 38.84 58.18 40.61 44.23 3.33 102.13-102.07 77.79-132.66z"
            fill="#bee5eb"
          ></path>
        </svg>
      </div>
    </div>
    <div
      class="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
      :class="{ show: showScheduleModal }"
      id="scheduleModal"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg relative w-auto pointer-events-none">
        <div
          class="modal-content px-8 py-6 border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
        >
          <h6 class="text-base font-medium mb-4">Harmonogram spłat kredytu</h6>
          <table class="min-w-full leading-normal mb-6">
            <thead>
              <tr>
                <th
                  class="px-2 py-2 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider text-center"
                >
                  Miesiąc
                </th>
                <th
                  class="hidden md:table-cell px-2 py-2 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider text-center"
                >
                  Część kapitałowa
                </th>
                <th
                  class="hidden md:table-cell px-2 py-2 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider text-center"
                >
                  Część odsetkowa
                </th>
                <th
                  class="px-2 py-2 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider text-center"
                >
                  Kwota raty
                </th>

                <th
                  class="px-2 py-2 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                ></th>
              </tr>
            </thead>
            <tbody v-if="result && result.harmonogram">
              <tr
                v-for="(e, i) in result.harmonogram"
                :key="'harmonogram_' + i"
              >
                <td
                  class="px-2 py-2 border-b border-gray-200 bg-white text-sm text-center"
                  :class="{
                    '!bg-[#e7f9eb]': e.surchage,
                    'text-[#04ae2a]': e.surchage,
                  }"
                >
                  {{ moment(i) }}
                </td>
                <td
                  class="hidden md:table-cell px-2 py-2 border-b border-gray-200 bg-white text-sm text-center"
                  :class="{
                    '!bg-[#e7f9eb]': e.surchage,
                    'text-[#04ae2a]': e.surchage,
                  }"
                >
                  <span v-if="e.surchage">---</span>
                  <span v-else>{{ e.asset }} zł</span>
                </td>
                <td
                  class="hidden md:table-cell px-2 py-2 border-b border-gray-200 bg-white text-sm text-center"
                  :class="{
                    '!bg-[#e7f9eb]': e.surchage,
                    'text-[#04ae2a]': e.surchage,
                  }"
                >
                  <span v-if="e.surchage">---</span>
                  <span v-else>{{ e.interest }} zł</span>
                </td>
                <td
                  class="px-2 py-2 border-b border-gray-200 bg-white text-sm text-center"
                  :class="{
                    '!bg-[#e7f9eb]': e.surchage,
                    'text-[#04ae2a]': e.surchage,
                  }"
                >
                  <span v-if="e.surchage">---</span>
                  <span v-else>{{ e.installment }} zł</span>
                </td>
                <td
                  class="px-2 py-2 border-b border-gray-200 bg-white text-sm text-center"
                  :class="{
                    '!bg-[#e7f9eb]': e.surchage,
                    'text-[#04ae2a]': e.surchage,
                  }"
                >
                  <span v-if="e.surchage">Wakacje i nadpłata</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="flex justify-end">
            <button
              type="button"
              class="btn ang-button py-1.5 px-4 _bg_color1"
              @click.stop.prevent="showScheduleModal = false"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
      :class="{ show: showContactModal }"
      id="contactModal"
      @click="resetContactForm()"
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-lg relative w-auto pointer-events-none"
        @click.stop=""
      >
        <div
          class="modal-content px-8 py-6 border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
        >
          <h4 class="text-xl font-medium mb-4">Umów bezpłatną konsultację</h4>
          <form
            role="form"
            id="contact-form"
            class=""
            action="/lead"
            method="POST"
            novalidate="novalidate"
          >
            <div class="row" v-if="contact_sent">
              <div class="col-md-12 mt-4 mb-7">
                <p class="font-semibold">
                  Dziękujemy za wypełnienie formularza.
                </p>
                <p>Skontaktujemy się z Tobą możliwie najszybciej.</p>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-lg-6 col-md-12 mt-2">
                <div class="form-group">
                  <label
                    class="ang-form-label sm:min-h-full"
                    for="current_balance"
                  >
                    Imię
                  </label>
                  <div class="relative">
                    <input
                      type="text"
                      class="ang-form-control"
                      name="first_name"
                      required
                    />
                  </div>
                </div>
              </div>
              <input type="hidden" name="city" value="." />
              <input
                type="hidden"
                name="lead_partner_uid"
                value="7d131c4b-4cd2-4dd1-8917-96083bfd552f"
              />
              <input
                type="hidden"
                name="source_uid"
                value="434c4648-0c4b-11ef-97df-8ea11ed63f6f"
              />
              <div class="col-lg-6 col-md-12 mt-2">
                <div class="form-group">
                  <label
                    class="ang-form-label sm:min-h-full"
                    for="current_balance"
                  >
                    Nazwisko
                  </label>
                  <div class="relative">
                    <input
                      type="text"
                      class="ang-form-control"
                      name="last_name"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 mt-2">
                <div class="form-group">
                  <label
                    class="ang-form-label sm:min-h-full"
                    for="current_balance"
                  >
                    Telefon komórkowy
                  </label>
                  <div class="relative">
                    <input
                      type="tel"
                      class="ang-form-control phone"
                      name="phone"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 mt-2">
                <div class="form-group">
                  <label
                    class="ang-form-label sm:min-h-full"
                    for="current_balance"
                  >
                    Adres email
                  </label>
                  <div class="relative">
                    <input
                      type="text"
                      class="ang-form-control email"
                      name="email"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 mt-2">
                <div class="mb-5">
                  <div class="flex relative text-justify pr-6 form-check-after">
                    <input
                      type="checkbox"
                      class="opacity-0 -mt-1.5 h-8 w-8 z-50 relative cursor-pointer !w-[25px]"
                      id="cos"
                      name="data[consents][ang_documents]"
                      value="1"
                      required
                    />
                    <label
                      class="label-checkbox w-full block mb-0 before:content-[''] before:absolute before:left-0 before:top-[5px] before:border before:border-pink before:h-4 before:rounded-md before:inline-block before:w-4 before:cursor-pointer after:content-[''] after:opacity-0 after:absolute after:top-[8px] after:left-[6px] after:w-[5px] after:h-[9px] after:border-r-2 after:border-b-2 after:border-pink after:rotate-45 after:text-pink after:block after:z-20 after:cursor-pointer"
                      for="cos"
                    >
                      <span class="cursor-pointer text-sm">
                        Zapoznałam/em się z treścią
                        <a
                          class="underline font-medium"
                          target="_blank"
                          href="https://drive.google.com/file/d/1FvUOC3VQQmhX-IqKFkrub3iLL7vt0OE_/view"
                          >Regulaminu usług Formularz kontaktowy</a
                        >
                        i akceptuję jego treść
                      </span>
                    </label>
                  </div>
                  <label class="cursor-pointer text-xs mt-6">
                    Akceptując
                    <a
                      class="underline font-medium"
                      target="_blank"
                      href="https://drive.google.com/file/d/1FvUOC3VQQmhX-IqKFkrub3iLL7vt0OE_/view"
                      >Regulamin usług Formularz kontaktowy</a
                    >
                    i klikając „Zamów bezpłatną rozmowę” zamawiasz rozmowę z ANG
                    Odpowiedzialne Finanse S.A. z siedzibą w Warszawie, zgodnie
                    z ww. regulaminem. Administratorem Twoich danych osobowych
                    jest ANG Odpowiedzialne Finanse S.A. z siedzibą w Warszawie,
                    a Twoje dane osobowe są przetwarzane w celi realizacji
                    usługi formularza kontaktowego i zamówienia rozmowy.
                    Szczegółowe informacje dotyczące przetwarzania Twoich danych
                    osobowych w związku ze świadczeniem usługi i o
                    przysługujących Ci prawach znajdziesz w punkcie VI.
                    <a
                      class="underline font-medium"
                      target="_blank"
                      href="https://drive.google.com/file/d/1FvUOC3VQQmhX-IqKFkrub3iLL7vt0OE_/view"
                      >Regulaminu usług Formularz kontaktowy</a
                    >.
                  </label>
                </div>
              </div>
            </div>
          </form>
          <div class="flex justify-between">
            <button
              type="button"
              id="closeContactModal"
              @click="resetContactForm()"
              class="btn ang-button py-1.5 px-4 _bg_color1"
            >
              Zamknij
            </button>
            <button
              v-if="!contact_sent"
              @click.stop.prevent="sendContact()"
              class="btn ang-button py-1.5 px-4 _bg_color2"
            >
              Zamów bezpłatną rozmowę
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#credit-holidays-form label.error,
#contact-form label.error {
  position: absolute;
  font-size: 11px;
}
#scheduleModal.show,
#contactModal.show {
  display: block !important;
  background-color: rgba(0, 0, 0, 0.5);
}
.accordion-button:not(.collapsed) {
  color: #47404f !important;
}
</style>
<script>
import datepicker from "eonasdan-bootstrap-datetimepicker"; // eslint-disable-line
import api from "@/services/api";
import ajax from "@/services/ajax";

import store from "@/store.js";
import moment from "moment";
import $ from "jquery";
import spinner from "@/components/partials/misc/spinner";

export default {
  data() {
    return {
      current_balance: 300000,
      current_installment: 2000,
      next_installment_date: null,
      current_interest: 8.75,
      rest_period: 240,
      loading: false,
      showContactModal: false,
      showScheduleModal: false,
      counter: 0,
      counter_function: null,
      sent: false,
      funds: {},
      token: null,
      result: null,
      current_date: null,
      token_expires_at: null,
      min_period: 0,
      contact_sent: false,
      section: 1,
    };
  },
  name: "Holidays",
  components: { spinner },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      self.datepickers();
      ajax.justValidate($("#credit-holidays-form"), function () {
        if (!self.loading && self.counter === 0) self.calc();
      });
      ajax.postValidate(
        $("#contact-form"),
        self,
        function () {
          self.contact_sent = true;
          // document.getElementById("closeContactModal").click();
        },
        function () {
          self.contact_sent = true;
          // document.getElementById("closeContactModal").click();
        }
      );
    });
    let params = {
      grant_type: "client_credentials",
      client_id: store.state.api.client_id,
      client_secret: store.state.api.client_secret,
    };
    api.post("/oauth/token", params, (data) => {
      self.token = data.access_token;
      self.token_expires_at = Date.now() + parseInt(data.expires_in);
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("token_expires_at", self.token_expires_at);
    });
  },
  watch: {
    next_installment_date() {
      this.current_date = moment().format("YYYY-MM-DD");
      let styczen = moment("2023-01-31");
      let dzis = moment(this.next_installment_date);
      this.min_period = styczen.diff(dzis, "months") + 1;
    },
    counter() {
      if (this.counter === 0) {
        clearInterval(this.counter_function);
      }
    },
  },
  methods: {
    sendContact() {
      $("#contact-form").submit();
    },
    resetContactForm() {
      let self = this;
      self.showContactModal = false;
      setTimeout(function () {
        self.contact_sent = false;
      }, 1000);
    },
    moment(data) {
      return moment(data).locale("pl").format("MMMM YYYY");
    },
    datepickers() {
      this.$nextTick(function () {
        $(".datepicker")
          .datetimepicker({
            locale: "pl",
            format: "YYYY-MM-DD",
          })
          .on("change", function () {
            $(this).valid();
          })
          .unbind("change")
          .unbind("dp.change")
          .on("dp.change", function (e) {
            let event = document.createEvent("HTMLEvents");
            event.initEvent("input", true, true);
            e.currentTarget.dispatchEvent(event);
            $(this).trigger("change");
            $(this).valid();
          });
      });
    },
    calc() {
      let self = this;
      self.counter = 2;
      this.counter_function = setInterval(function () {
        self.counter -= 1;
      }, 1000);
      let params = {
        interest: self.current_interest,
        saldo: self.current_balance,
        period: self.rest_period,
        next_installment_date: self.next_installment_date,
      };
      self.loading = true;
      api.get(
        "/holiday",
        params,
        function (data) {
          self.result = data;
          self.loading = false;
        },
        function () {
          self.loading = false;
        },
        null,
        {
          Authorization: `Bearer ${self.token}`,
        }
      );
    },
  },
};
</script>
